import { render, staticRenderFns } from "./pressure.vue?vue&type=template&id=ef342fb0&scoped=true&"
import script from "./pressure.vue?vue&type=script&lang=js&"
export * from "./pressure.vue?vue&type=script&lang=js&"
import style0 from "./pressure.vue?vue&type=style&index=0&id=ef342fb0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef342fb0",
  null
  
)

export default component.exports